import React, { Component } from 'react';
import {
    Link,
    NavLink,
    withRouter
} from "react-router-dom";
import {connect} from 'react-redux';
import { Layout as AntLayout, Menu, Icon } from 'antd';
import {logoutUser} from '../actions';
const { Header, Content, Footer } = AntLayout;
const {SubMenu} = Menu;

class Layout extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedMenu: ''
        }
    }
    static getDerivedStateFromProps(nextProps) {
        return {selectedMenu: nextProps.location.pathname};
    }
    renderLogin() {
        const {auth: {isAuthenticated}, me: {name}} = this.props;
        if (isAuthenticated) {
            return (
                <SubMenu title={<span><Icon type="user" />{name}</span>}>
                    <Menu.Item key="logout"><Icon type="logout" /><span>Logout</span></Menu.Item>
                </SubMenu>
            );
        }
        return <Menu.Item key="2"><NavLink to="/login"><Icon type="login" /><span>Login</span></NavLink></Menu.Item>;
    }
    logoutUser({item, key, keyPath}) {
        if (key !== 'logout') return;
        return this.props.logoutUser().then(() => {
            return this.props.history.replace('/');
        });
    }
    render() {
        const {renderSidebar = () => {}} = this.props;
        const {selectedMenu} = this.state;

        return (
            <AntLayout style={{height:"100vh"}}>
                <Header className="header" style={{display: 'flex', justifyContent: 'space-between'}}>
                    <Link to="/">
                        <div id="logo">
                        </div>
                    </Link>
                    <Menu
                        theme="dark"
                        mode="horizontal"
                        style={{ lineHeight: '64px', display: 'flex' }}
                        defaultSelectedKeys={[selectedMenu]}
                        onClick={this.logoutUser.bind(this)}
                    >
                        <Menu.Item key="/enquire"><NavLink to="/enquire">Make Enquire</NavLink></Menu.Item>
                        {this.renderLogin()}
                    </Menu>
                </Header>
                <AntLayout>
                    {renderSidebar({...this.props, ...this.state})}
                    <AntLayout style={{ padding: '24px', paddingBottom: 0, background: '#fff', overflowX: 'hidden' }}>
                        <Content style={{ margin: 0, position: 'relative' }}>
                            {this.props.children}
                        </Content>
                    </AntLayout>
                </AntLayout>
            </AntLayout>
        );
    }
}

function mapStateToProps(state) {
    const {auth, me} = state;
    return Object.assign({}, {auth, me});
}

export default withRouter(connect(mapStateToProps, {logoutUser})(Layout));


// WEBPACK FOOTER //
// ./resources/assets/js/components/Layout.js